import { ServiceLocalizationFallbackType } from '../types';
import { AbstractLocaleHandler } from './AbstractLocaleHandler';
import { StateParamHandlerService } from '../../../services/stateParamHandlerService';
import getPathLocale from '../utils/getPathLocale';
import getValueByInsensitiveKey from '../../../utils/getValueByInsensitiveKey';

export type StateParamLocaleHandlerPropsType = {
  languagesFallback: ServiceLocalizationFallbackType;
};

export default class StateParamLocaleHandler extends AbstractLocaleHandler {
  constructor(languagesFallback: ServiceLocalizationFallbackType) {
    super(languagesFallback);
  }

  public handle(
    isLanguage: boolean,
    currentList: string[]
  ): string | undefined {
    // the navigation service is not initialized yet
    const searchParams = new URLSearchParams(window?.location?.search);
    const stateParamEncoded = searchParams?.get('state');
    const { postLogoutRedirect: postLogoutRedirectPath } =
      StateParamHandlerService.decodeStateParam(stateParamEncoded) || {};

    const postLogoutRedirectPathLocale = getPathLocale(postLogoutRedirectPath);

    // For fallback
    const postLogoutRedirectPathLocaleFallback = getValueByInsensitiveKey(
      this._languagesFallback,
      postLogoutRedirectPathLocale?.language
    );

    return this.genericHandle({
      isLanguage: isLanguage,
      locale: postLogoutRedirectPathLocale,
      currentList: currentList,
      localeFallback: postLogoutRedirectPathLocaleFallback
    });
  }
}
